import React, { ComponentPropsWithoutRef } from 'react';
import { Required, StyledLabel } from './Label.styles';

type LabelProps = ComponentPropsWithoutRef<'label'> & {
  required?: boolean;
  children: React.ReactNode;
};

export function Label({ required, children, ...rest }: LabelProps) {
  return (
    <StyledLabel {...rest}>
      {children}
      {required && <Required>*</Required>}
    </StyledLabel>
  );
}
